import { updateObject } from "utils/helpers/updateObject";
import { FeaturedAdsState, initialState } from "./state";
import { actionTypes, CreateFeaturedAdsFailureAction, CreateFeaturedAdsRequestAction, CreateFeaturedAdsSuccessAction, DeleteFeaturedAdsFailureAction, DeleteFeaturedAdsRequestAction, DeleteFeaturedAdsSuccessAction, FeaturedAdsActions, FetchFeaturedAdsFailureAction, FetchFeaturedAdsRequestAction, FetchFeaturedAdsSuccessAction, ResetFeaturedAdsAction, stateStatusType, UpdateFeaturedAdsFailureAction, UpdateFeaturedAdsRequestAction, UpdateFeaturedAdsSuccessAction, UploadFeaturedAdsVideoFailureAction, UploadFeaturedAdsVideoRequestAction, UploadFeaturedAdsVideoSuccessAction } from './actionType';

const fetchFeaturedAdsRequest = (
  state: FeaturedAdsState,
  action: FetchFeaturedAdsRequestAction
) => {
  return updateObject(state, {
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchFeaturedAdsSuccess = (
  state: FeaturedAdsState,
  action: FetchFeaturedAdsSuccessAction
) => {
  return updateObject(state, {
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      featuredAds: action.payload,
    },
  });
};

const fetchFeaturedAdsFail = (
  state: FeaturedAdsState,
  action: FetchFeaturedAdsFailureAction
) => {
  return updateObject(state, {
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const createFeaturedAdsRequest = (
  state: FeaturedAdsState,
  action: CreateFeaturedAdsRequestAction
) => {
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createFeaturedAdsSuccess = (
  state: FeaturedAdsState,
  action: CreateFeaturedAdsSuccessAction
) => {
    const existingFeaturedAds= state.featuredAdsState.featuredAds || []
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      featuredAds: [...existingFeaturedAds, action.payload ],
    },
  });
};

const createFeaturedAdsFail = (
  state: FeaturedAdsState,
  action: CreateFeaturedAdsFailureAction
) => {
  return updateObject(state, {
     genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const updateFeaturedAdsRequest = (
  state: FeaturedAdsState,
  action: UpdateFeaturedAdsRequestAction
) => {
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const updateFeaturedAdsSuccess = (
  state: FeaturedAdsState,
  action: UpdateFeaturedAdsSuccessAction
) => {
    const newExistingFeaturedAds = state.featuredAdsState.featuredAds?.map(
    (item) => (item.id === action.payload.id ? action.payload : item)
  ) ?? [action.payload];
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      featuredAds: [...newExistingFeaturedAds ],
    },
  });
};

const updateFeaturedAdsFail = (
  state: FeaturedAdsState,
  action: UpdateFeaturedAdsFailureAction
) => {
  return updateObject(state, {
     genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const uploadFeaturedAdsVideoRequest = (
  state: FeaturedAdsState,
  action: UploadFeaturedAdsVideoRequestAction
) => {
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const uploadFeaturedAdsVideoSuccess = (
  state: FeaturedAdsState,
  action: UploadFeaturedAdsVideoSuccessAction
) => {
  const existingData = state.featuredAdsState.featuredAds
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      featuredAds: existingData,
      featuredAdsVideo: action.payload
    },
  });
};

const uploadFeaturedAdsVideoFail = (
  state: FeaturedAdsState,
  action: UploadFeaturedAdsVideoFailureAction
) => {
  return updateObject(state, {
     genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const deleteFeaturedAdsRequest = (
  state: FeaturedAdsState,
  action: DeleteFeaturedAdsRequestAction
) => {
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const deleteFeaturedAdsSuccess = (
  state: FeaturedAdsState,
  action: DeleteFeaturedAdsSuccessAction
) => {
    const existingFeaturedAds= state.featuredAdsState.featuredAds ?? []
    const newFeaturedAds = existingFeaturedAds.filter((item)=> item.id !== action.payload);
  return updateObject(state, {
    genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    featuredAdsState: {
      ...state.featuredAdsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      featuredAds: newFeaturedAds,
    },
  });
};

const deleteFeaturedAdsFail = (
  state: FeaturedAdsState,
  action: DeleteFeaturedAdsFailureAction
) => {
  return updateObject(state, {
     genericFeaturedAdsState: {
      ...state.genericFeaturedAdsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const resetFeaturedAds = (state: FeaturedAdsState, action: ResetFeaturedAdsAction) => ({
  ...state,
  genericFeaturedAdsState: { ...initialState.genericFeaturedAdsState },
});

const fetchFeaturedAdsReducer = (state = initialState, action: FeaturedAdsActions) => {
  switch (action.type) {
    case actionTypes.FETCH_FEATURED_ADS_REQUEST:
      return fetchFeaturedAdsRequest(state, action);
    case actionTypes.FETCH_FEATURED_ADS_SUCCESS:
      return fetchFeaturedAdsSuccess(state, action);
    case actionTypes.FETCH_FEATURED_ADS_FAIL:
      return fetchFeaturedAdsFail(state, action);
    case actionTypes.CREATE_FEATURED_ADS_REQUEST:
      return createFeaturedAdsRequest(state, action);
    case actionTypes.CREATE_FEATURED_ADS_SUCCESS:
      return createFeaturedAdsSuccess(state, action);
    case actionTypes.CREATE_FEATURED_ADS_FAIL:
      return createFeaturedAdsFail(state, action);
    case actionTypes.UPDATE_FEATURED_ADS_REQUEST:
      return updateFeaturedAdsRequest(state, action);
    case actionTypes.UPDATE_FEATURED_ADS_SUCCESS:
      return updateFeaturedAdsSuccess(state, action);
    case actionTypes.UPDATE_FEATURED_ADS_FAIL:
      return updateFeaturedAdsFail(state, action);
    case actionTypes.UPLOAD_FEATURED_ADS_VIDEO_REQUEST:
      return uploadFeaturedAdsVideoRequest(state, action);
    case actionTypes.UPLOAD_FEATURED_ADS_VIDEO_SUCCESS:
      return uploadFeaturedAdsVideoSuccess(state, action);
    case actionTypes.UPLOAD_FEATURED_ADS_VIDEO_FAIL:
      return uploadFeaturedAdsVideoFail(state, action);
    case actionTypes.DELETE_FEATURED_ADS_REQUEST:
      return deleteFeaturedAdsRequest(state, action);
    case actionTypes.DELETE_FEATURED_ADS_SUCCESS:
      return deleteFeaturedAdsSuccess(state, action);
    case actionTypes.DELETE_FEATURED_ADS_FAIL:
      return deleteFeaturedAdsFail(state, action);
    case actionTypes.RESET_FEATURED_ADS:
      return resetFeaturedAds(state, action);
    default:
      return state;
  }
};

export default fetchFeaturedAdsReducer;